import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
  checkDate()
);

function checkDate() {

  // get current date for reference
  var today = new Date(),
  date = (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getFullYear();
  console.log(date);

  // 1. if date exists in local storage AND it is current date (same day)
  // 2. (if date exists in local storage AND it is NOT current date (different day)) OR (date does not exist in local storage (first time visiting website))

  if (localStorage.getItem("todayDate") == date){
    console.log("DO NOTHING")
  }
  else {
    localStorage.clear();
    localStorage.setItem("todayDate", date);
  }
};
  
serviceWorker.unregister();
